import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.less'],
})
export class ContactUsComponent implements OnInit {
  constructor(
  ) { }

  ngOnInit(): void {
  }

  tabs = ['Phone'];
  selectedTab = 'Phone';

  selectTab(tab: string) {
    this.selectedTab = tab;
  }

}
